import InitialState from '../initial-state';
import { ActionTypes } from './actions';

export default function reducer(state = InitialState.getState().kambiWidget, action) {

  switch (action.type) {
    case ActionTypes.SET_LATEST_OUTCOMES:
      return {
        ...state,
        outcomes: action.outcomes
      };
    case ActionTypes.SET_QUEUED_OUTCOME:
      return {
        ...state,
        queuedOutcomes: {
          ...state.queuedOutcomes,
          [action.outcome.outcomeId]: action.outcome
        }
      };
    case ActionTypes.CLEAR_QUEUED_OUTCOMES:
      return {
        ...state,
        queuedOutcomes: {}
      };

    default:
      return state;
  }
}
